import React from 'react';

import PageSection, { PageSectionType } from './PageSection';
import TwoColCardsSection from './TwoColCardsSection';

const ArchitectureSection: React.FC = () => {
  return (
    <PageSection type={PageSectionType.BlueElectric}>
      <TwoColCardsSection
        eyebrow="Architecture"
        heading="Vector Search + Knowledge Graph, with auditability built in."
        body="The Knowledge Graph captures the relationships that matter in your environment: your legislation, your policy hierarchy, your departmental structure, your vendor and grantee networks. Vector Search retrieves the right passages from your documents and grounds every answer with citations. Every agent decision is logged and traceable. Deployment is on your infrastructure (on-premise or sovereign cloud), so your data never leaves your environment."
        cards={[
          {
            label: 'Human-in-the-Loop',
            abbr: 'HITL',
            description:
              "A human officer validates every output before it's used. The right choice wherever an incorrect answer creates legal exposure, audit risk, or a public accountability problem.",
            points: [
              'Policy guidance, procurement rulings, any externally-facing output',
              'Procurement decisions and contract compliance findings',
              'New deployments: tighter supervision while trust is established',
            ],
          },
          {
            label: 'Human-on-the-Loop',
            abbr: 'HOTL',
            description:
              'The agent operates autonomously, your team supervises by exception. Appropriate for high-volume internal workflows where the cost of stopping for validation outweighs the risk.',
            points: [
              'IT helpdesk triage and internal FAQ handling',
              'Document classification and records routing',
              'Mature deployments: graduate workflows as accuracy is proven',
            ],
          },
        ]}
        footer="All agents can be configured in either mode per workflow. Most deployments start fully HITL and move individual workflows to HOTL as institutional confidence builds."
      />
    </PageSection>
  );
};

ArchitectureSection.displayName = 'ArchitectureSection';
export default ArchitectureSection;
